import { apiAction } from '../apiAction';

import { fetchAccountDetailsTypes } from './types';
import * as api from './api';

export const fetchAccountDetails = apiAction({
  types: fetchAccountDetailsTypes,
  apiAction: api.fetchAccountDetails,
});
